// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609232104/js/" + chunkId + "." + {"44":"a0cfd85f","225":"8ab79bbc","481":"b0e4e67e","486":"c1ee6291","770":"74e93c97"}[chunkId] + ".0.6910933214513812.chunk.js";
};